<life-di-nav></life-di-nav>
<lifedi-breadcrumb lastPath="จัดการ consult"></lifedi-breadcrumb>

<div class="container">
  <div class="row">
    <div class="col-lg-1 col-md-1 col-sm-2 col-2">
      <label for="date" class="col-form-label">วันที่</label>
    </div>
    <div class="col-5">
      <form [formGroup]="dateForm">
        <input type="text" id="date" class="form-control" placement="bottom" formControlName="date"
          [ngModel]="dateForm.value.date" bsDatepicker [(bsValue)]="dateForm.value.date"
          value="{{ dateForm.value.date | date:'DD/MM/YYYY' }}"
          [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }">
      </form>
    </div>
  </div>
  <div class="container-fulid" style="margin-top: 12%;">
    <div class="row justify-content-center">
      <lifedi-btn *ngIf="dateForm.value.date" lable="เพิ่มช่วงเวลา"
        customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;"
        (click)="add(dateForm.value.date)">
      </lifedi-btn>
      <lifedi-btn *ngIf="!dateForm.value.date" disabled="true" lable="เพิ่มช่วงเวลา"
        customStyle="margin: 0px; padding: 0 30px;">
      </lifedi-btn>
    </div>
    <div class="row justify-content-center">
      <h4 class="mt-4 mb-4">หรือ</h4>
    </div>
    <div class="row justify-content-center">
      <lifedi-btn *ngIf="dateForm.value.date" lable="Duplicate ช่วงเวลา" (click)="duplicate(dateForm.value.date)"
        customStyle="background-color: #A90088; color: #FFF; margin: 0px; padding: 0 30px;">
      </lifedi-btn>
      <lifedi-btn *ngIf="!dateForm.value.date" disabled="true" lable="Duplicate ช่วงเวลา"
        customStyle="margin: 0px; padding: 0 30px;">
      </lifedi-btn>
    </div>
  </div>
</div>
